import { render, staticRenderFns } from "./SettingCompany.vue?vue&type=template&id=71e0c712&scoped=true&"
import script from "./SettingCompany.vue?vue&type=script&lang=js&"
export * from "./SettingCompany.vue?vue&type=script&lang=js&"
import style0 from "./SettingCompany.vue?vue&type=style&index=0&id=71e0c712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e0c712",
  null
  
)

export default component.exports